const blankState = {
  site_track: {
    count: 0,
    subsections: {}
  },
  site_command: {
    count: 0,
    subsections: {}
  },
  site_scan: {
    count: 0,
    subsections: {}
  },
  site_unite: {
    count: 0,
    subsections: {}
  },
  alerts: {
    count: 0,
    subsections: {}
  },
  reports: {
    count: 0,
    subsections: {}
  },
  configuration: {
    count: 0,
    subsections: {}
  },
}

const state = {
  notifications: JSON.parse(JSON.stringify(blankState))
}
const getters = {
  sidemenuNotifications: state => state.notifications,
  totalNotifications(state) {
    let total = 0
    for (let module of Object.values(state.notifications)) {
      total += module.count
    }
    return total
  }
}
const mutations = {
  setSideMenuNotifications(state, [key, value]) {
    state.notifications[key] = value
  },
  resetNotifications(state) {
    state.notifications = JSON.parse(JSON.stringify(blankState))
  }
}

export default {
  state,
  getters,
  mutations
}